
//-------------------- Public
export const VALIDATIONS = "VALIDATIONS";
export const SHOWBUTTONNAVIGATION = "SHOWBUTTONNAVIGATION";
export const ORDERFROMTRACKING = "ORDERFROMTRACKING";

//-------------------- loading
export const IS_LOADING = "IS_LOADING";

//-------------------- splash page
export const IS_SPLASH = "IS_SPLASH";

//-------------------- user info
export const USER_INFO = "USER_INFO";
export const THEME_SITE = "THEME_SITE";

//-------------------- dashboard
export const ACTIVE_MENU = "ACTIVE_MENU";



//-------------------- single order
// sender
export const FIRST_NAME_SENDER_SINGLE = "FIRST_NAME_SENDER_SINGLE";
export const LAST_NAME_SENDER_SINGLE = "LAST_NAME_SENDER_SINGLE";
export const NATIONAL_CODE_SENDER_SINGLE = "NATIONAL_CODE_SENDER_SINGLE";
export const POSTAL_CODE_SENDER_SINGLE = "POSTAL_CODE_SENDER";
export const MOBILE_NUMBER_SENDER_SINGLE = "MOBILE_NUMBER_SENDER_SINGLE";
export const PHONE_NUMBER_SENDER_SINGLE = "PHONE_NUMBER_SENDER_SINGLE";
export const ADDRESS_SENDER_SINGLE = "ADDRESS_SENDER";
export const EMAIL_SENDER_SINGLE = "EMAIL_SENDER_SINGLE";
export const COMPANY_SENDER_SINGLE = "COMPANY_SENDER_SINGLE";
export const LAT_SENDER_SINGLE = "LAT_SENDER_SINGLE";
export const LNG_SENDER_SINGLE = "LNG_SENDER_SINGLE";
export const CITY_NAME_SENDER_SINGLE = "CITY_NAME_SENDER_SINGLE";
export const CITY_ID_SENDER_SINGLE = "CITY_ID_SENDER_SINGLE";
export const STATE_NAME_SENDER_SINGLE = "STATE_NAME_SENDER_SINGLE";
export const STATE_ID_SENDER_SINGLE = "STATE_ID_SENDER_SINGLE";
export const NEED_SENDER_SINGLE = "NEED_SENDER_SINGLE";
export const RESET_STATE_SENDER_SINGLE = "RESET_STATE_SENDER_SINGLE";

// receiver
export const FIRST_NAME_RECEIVER_SINGLE = "FIRST_NAME_RECEIVER_SINGLE";
export const LAST_NAME_RECEIVER_SINGLE = "LAST_NAME_RECEIVER_SINGLE";
export const NATIONAL_CODE_RECEIVER_SINGLE = "NATIONAL_CODE_RECEIVER_SINGLE";
export const POSTAL_CODE_RECEIVER_SINGLE = "POSTAL_CODE_RECEIVER_SINGLE";
export const MOBILE_NUMBER_RECEIVER_SINGLE = "MOBILE_NUMBER_RECEIVER_SINGLE";
export const PHONE_NUMBER_RECEIVER_SINGLE = "PHONE_NUMBER_RECEIVER_SINGLE";
export const ADDRESS_RECEIVER_SINGLE = "ADDRESS_RECEIVER_SINGLE";
export const EMAIL_RECEIVER_SINGLE = "EMAIL_RECEIVER_SINGLE";
export const COMPANY_RECEIVER_SINGLE = "COMPANY_RECEIVER_SINGLE";
export const LAT_RECEIVER_SINGLE = "LAT_RECEIVER_SINGLE";
export const LNG_RECEIVER_SINGLE = "LNG_RECEIVER_SINGLE";
export const CITY_NAME_RECEIVER_SINGLE = "CITY_NAME_RECEIVER_SINGLE";
export const CITY_ID_RECEIVER_SINGLE = "CITY_ID_RECEIVER_SINGLE";
export const STATE_NAME_RECEIVER_SINGLE = "STATE_NAME_RECEIVER_SINGLE";
export const STATE_ID_RECEIVER_SINGLE = "STATE_ID_RECEIVER_SINGLE";
export const NEED_RECEIVER_SINGLE = "NEED_RECEIVER_SINGLE";
export const RESET_STATE_RECEIVER_SINGLE = "RESET_STATE_RECEIVER_SINGLE";
export const COUNTRY_NAME_RECEIVER_SINGLE = "COUNTRY_NAME_RECEIVER_SINGLE";
export const COUNTRY_ID_RECEIVER_SINGLE = "COUNTRY_ID_RECEIVER_SINGLE";
export const COUNTRY_NAME_EN_RECEIVER_SINGLE = "COUNTRY_NAME_EN_RECEIVER_SINGLE";
export const COUNTRY_CITY_RECEIVER_SINGLE = "COUNTRY_CITY_RECEIVER_SINGLE";



// info box
export const INFO_BOX_SINGLE = "INFO_BOX_SINGLE";
export const PRICE_BOX_SINGLE = "PRICE_BOX_SINGLE";
export const WEIGHT_BOX_SINGLE = "WEIGHT_BOX_SINGLE";
export const SIZE_BOX_SINGLE = "SIZE_BOX_SINGLE";
export const WIDTH_BOX_SINGLE = "WIDTH_BOX_SINGLE";
export const HEIGHT_BOX_SINGLE = "HEIGHT_BOX_SINGLE";
export const LENGTH_BOX_SINGLE = "LENGTH_BOX_SINGLE";
export const NEED_BOX_SINGLE = "NEED_BOX_SINGLE";
export const FACTOR_BOX_SINGLE = "FACTOR_BOX_SINGLE";
export const NOTIFICATION_BOX_SINGLE = "NOTIFICATION_BOX_SINGLE";
export const TRADEMARK_BOX_SINGLE = "TRADEMARK_BOX_SINGLE";
export const BREAKABLE_BOX_SINGLE = "BREAKABLE_BOX_SINGLE";
export const LIQUID_BOX_SINGLE = "LIQUID_BOX_SINGLE";
export const PAYMENT_TYPE_BOX_SINGLE = "PAYMENT_TYPE_BOX_SINGLE";
export const AGENT_SERVICES_BOX_SINGLE = "AGENT_SERVICES_BOX_SINGLE";
export const RESET_STATE_BOX_SINGLE = "RESET_STATE_BOX_SINGLE";
export const POST_TYPE_BOX_SINGLE = "POST_TYPE_BOX_SINGLE";
export const SHIPMENT_TYPE_BOX_SINGLE = "SHIPMENT_TYPE_BOX_SINGLE";
export const IS_WORKED_BOX_SINGLE = "IS_WORKED_BOX_SINGLE";
export const SHIPMENT_IMAGES_BOX_SINGLE = "SHIPMENT_IMAGES_BOX_SINGLE";
export const IS_Insurance_BOX_SINGLE = "IS_Insurance_BOX_SINGLE";

// review
export const LIST_REVIEW_SINGLE = "LIST_REVIEW_SINGLE";
export const RESET_STATE_REVIEW_SINGLE = "RESET_STATE_REVIEW_SINGLE";

// services
export const LIST_SERVICES_SINGLE = "LIST_SERVICES_SINGLE";
export const SELECTED_SERVICES_SINGLE = "SELECTED_SERVICES_SINGLE";
export const PAYMENT_TYPE_SERVICES_SINGLE = "PAYMENT_TYPE_SERVICES_SINGLE";
export const TOTAL_PRICE_SERVICES_SINGLE = "TOTAL_PRICE_SERVICES_SINGLE";
export const SERVICE_PRICE_SERVICES_SINGLE = "SERVICE_PRICE_SERVICES_SINGLE";
export const SELECTED_SERVICES_FROM_MAP_SINGLE = "SELECTED_SERVICES_FROM_MAP_SINGLE";
export const RESET_STATE_SERVICES_SINGLE = "RESET_STATE_SERVICES_SINGLE";




//-------------------- multi order
// sender
export const SERVICES_SENDER_MULTI = "SERVICES_SENDER_MULTI";
export const SERVICES_NAME_SENDER_MULTI = "SERVICES_NAME_SENDER_MULTI";
export const FIRST_NAME_SENDER_MULTI = "FIRST_NAME_SENDER_MULTI";
export const LAST_NAME_SENDER_MULTI = "LAST_NAME_SENDER_MULTI";
export const NATIONAL_CODE_SENDER_MULTI = "NATIONAL_CODE_SENDER_MULTI";
export const POSTAL_CODE_SENDER_MULTI = "POSTAL_CODE_SENDER_MULTI";
export const MOBILE_NUMBER_SENDER_MULTI = "MOBILE_NUMBER_SENDER_MULTI";
export const PHONE_NUMBER_SENDER_MULTI = "PHONE_NUMBER_SENDER_MULTI";
export const ADDRESS_SENDER_MULTI = "ADDRESS_SENDER_MULTI";
export const EMAIL_SENDER_MULTI = "EMAIL_SENDER_MULTI";
export const COMPANY_SENDER_MULTI = "COMPANY_SENDER_MULTI";
export const LAT_SENDER_MULTI = "LAT_SENDER_MULTI";
export const LNG_SENDER_MULTI = "LNG_SENDER_MULTI";
export const CITY_NAME_SENDER_MULTI = "CITY_NAME_SENDER_MULTI";
export const CITY_ID_SENDER_MULTI = "CITY_ID_SENDER_MULTI";
export const STATE_NAME_SENDER_MULTI = "STATE_NAME_SENDER_MULTI";
export const STATE_ID_SENDER_MULTI = "STATE_ID_SENDER_MULTI";
export const NEED_SENDER_MULTI = "NEED_SENDER_MULTI"
export const FACTOR_SENDER_MULTI = "FACTOR_SENDER_MULTI"
export const NOTIFICATION_SENDER_MULTI = "NOTIFICATION_SENDER_MULTI"
export const TRADEMARK_SENDER_MULTI = "TRADEMARK_SENDER_MULTI"
export const BREAKABLE_SENDER_MULTI = "BREAKABLE_SENDER_MULTI"
export const LIQUID_SENDER_MULTI = "LIQUID_SENDER_MULTI"
export const CARTOON_SENDER_MULTI = "CARTOON_SENDER_MULTI"
export const SELECTED_SERVICES_FROM_MAP_MULTI = "SELECTED_SERVICES_FROM_MAP_MULTI"
export const RESET_STATE_SENDER_MULTI = "RESET_STATE_SENDER_MULTI"

// receiver
export const FIRST_NAME_RECEIVER_MULTI = "FIRST_NAME_RECEIVER_MULTI";
export const LAST_NAME_RECEIVER_MULTI = "LAST_NAME_RECEIVER_MULTI";
export const NATIONAL_CODE_RECEIVER_MULTI = "NATIONAL_CODE_RECEIVER_MULTI";
export const POSTAL_CODE_RECEIVER_MULTI = "POSTAL_CODE_RECEIVER_MULTI";
export const MOBILE_NUMBER_RECEIVER_MULTI = "MOBILE_NUMBER_RECEIVER_MULTI";
export const PHONE_NUMBER_RECEIVER_MULTI = "PHONE_NUMBER_RECEIVER_MULTI";
export const ADDRESS_RECEIVER_MULTI = "ADDRESS_RECEIVER_MULTI";
export const EMAIL_RECEIVER_MULTI = "EMAIL_RECEIVER_MULTI";
export const COMPANY_RECEIVER_MULTI = "COMPANY_RECEIVER_MULTI";
export const LAT_RECEIVER_MULTI = "LAT_RECEIVER_MULTI";
export const LNG_RECEIVER_MULTI = "LNG_RECEIVER_MULTI";
export const CITY_NAME_RECEIVER_MULTI = "CITY_NAME_RECEIVER_MULTI";
export const CITY_ID_RECEIVER_MULTI = "CITY_ID_RECEIVER_MULTI";
export const STATE_NAME_RECEIVER_MULTI = "STATE_NAME_RECEIVER_MULTI";
export const STATE_ID_RECEIVER_MULTI = "STATE_ID_RECEIVER_MULTI";
export const NEED_RECEIVER_MULTI = "NEED_RECEIVER_MULTI";
export const RESET_STATE_RECEIVER_MULTI = "RESET_STATE_RECEIVER_MULTI";

// info box
export const LIST_INFO_BOX_MULTI = "LIST_INFO_BOX_MULTI";
export const EXCEL_LIST_INFO_BOX_MULTI = "EXCEL_LIST_INFO_BOX_MULTI";
export const INSURANCE_BOX_MULTI = "INSURANCE_BOX_MULTI";
export const INFO_BOX_MULTI = "INFO_BOX_MULTI";
export const PRICE_BOX_MULTI = "PRICE_BOX_MULTI";
export const WEIGHT_BOX_MULTI = "WEIGHT_BOX_MULTI";
export const SIZE_BOX_MULTI = "SIZE_BOX_MULTI";
export const LENGTH_BOX_MULTI = "LENGTH_BOX_MULTI";
export const WIDTH_BOX_MULTI = "WIDTH_BOX_MULTI";
export const HEIGHT_BOX_MULTI = "HEIGHT_BOX_MULTI";
export const AGENT_SERVICES_BOX_MULTI = "AGENT_SERVICES_BOX_MULTI";
export const RESET_STATE_BOX_MULTI = "RESET_STATE_BOX_MULTI";

